export const jidsRetailerContactInfo = [
  'Antilles',
  'California',
  'Colorado',
  'Connecticut',
  'Florida',
  'Georgia',
  'Indiana',
  'Kentucky',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Nebraska',
  'New Jersey',
  'New York',
  'North Carolina',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Texas',
  'Washington',
  'West Virginia',
  'Wisconsin',
];
